module.exports = __webpack_public_path__ + "img/Aspect Base Edge Guide2.800abf4d.jpg";